module.exports = __webpack_public_path__ + "img/jo.5c6b019f.svg";